export default "__VITE_ASSET__2720a783__"